"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _iconcontrol_styles = _interopRequireDefault(require("./iconcontrol_styles"));

var _iconcontrol_definition = _interopRequireDefault(require("./iconcontrol_definition"));

var _definecomponent = require("../../../utils/definecomponent");

var _icon = _interopRequireDefault(require("../../graphic/icon/icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// utils
// styles
// definition
// icon

/* ========== ~~~~~~~~~~ EXPORT : CONTROLS : CONTROL ~~~~~~~~~~ ========== */


var IconControl = (0, _reactJss.default)(_iconcontrol_styles.default)(function (props) {
  var handleControlSelect = function handleControlSelect() {
    props.handleSelect(props.value);
  };

  return _react.default.createElement("div", {
    className: "iconcontrol ".concat(props.classes.iconcontrol, " selected-").concat(props.selected, " name-ctl-").concat((0, _index.generateName)(props.text)),
    onClick: handleControlSelect
  }, _react.default.createElement("div", {
    className: "content"
  }, _react.default.createElement("img", {
    className: 'moderationimg',
    src: props.image
  }), _react.default.createElement("div", {
    className: 'moderationtype'
  }, props.text), _react.default.createElement("div", {
    className: "trianglecontainer"
  }, _react.default.createElement("div", {
    className: 'triangle'
  }, _react.default.createElement(_icon.default, {
    name: "check"
  })))));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(IconControl, _iconcontrol_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = IconControl;
exports.default = _default;